// required to prevent vuetify i18n from showing errors
export default defineI18nConfig(() => ({
    legacy: false,
    missingWarn: false,
    fallbackWarn: false,
}))
